import { useState, useEffect } from 'react';
import QueueService from '../../Queue/service/index';

/**
 * @typedef {Object} Queue
 * @property {number} id - Identificador da fila.
 * @property {number} timeout - Tempo de espera.
 * @property {string} musiconhold - Música de espera.
 * @property {number} wrapuptime - Tempo de finalização.
 * @property {boolean} autopause - Pausa automática.
 * @property {boolean} ringinuse - Tocar enquanto em uso.
 * @property {string} strategy - Estratégia de distribuição de chamadas.
 * @property {string} name - Nome da fila.
 * @property {string} periodic_announce - Anúncio periódico.
 * @property {number} periodic_announce_frequency - Frequência do anúncio periódico.
 * @property {boolean} fila_personalizada - Fila personalizada.
 * @property {string} foraHorario - Mensagem fora do horário.
 * @property {boolean} disable - Desabilitar fila.
 * @property {number|null} announceFrequency - Frequência do anúncio.
 * @property {boolean} announcePosition - Anunciar posição na fila.
 * @property {string} closing_message - Mensagem de encerramento.
 * @property {boolean} closing_message_enabled - Mensagem de encerramento habilitada.
 * @property {string} greeting_message - Mensagem de saudação.
 * @property {boolean} greeting_message_enabled - Mensagem de saudação habilitada.
 * @property {string} transfer_message - Mensagem de transferência.
 * @property {boolean} transfer_message_enabled - Mensagem de transferência habilitada.
 * @property {boolean} send_attendant_name - Enviar nome do atendente.
 * @property {string} strategy_chat - Estratégia de distribuição de chat.
 * @property {number} max_chat_per_user - Máximo de chats por usuário.
 * @property {string} chat_overflow - Transbordo de chat.
 * @property {number|null} queue_of_chat_overflow - Fila de transbordo de chat.
 * @property {string} message_of_chat_overflow - Mensagem de transbordo de chat.
 * @property {boolean} active_chat_in_chat_distribution - Chat ativo na distribuição de chat.
 * @property {number} scheduleTime_id - Identificador do horário agendado.
 * @property {number} centrodecustoId - Identificador do centro de custo.
 * @property {number|null} callback_id - Identificador de callback.
 * @property {string} color - Cor da fila.
 * @property {boolean} is_chat - Indica se é uma fila de chat.
 * @property {boolean} is_telephony - Indica se é uma fila de telefonia.
 * @property {number} levelOfService - Nível de serviço.
 * @property {Object} centrodecusto - Centro de custo.
 * @property {number} centrodecusto.id - Identificador do centro de custo.
 * @property {string} centrodecusto.name - Nome do centro de custo.
 * @property {string} centrodecusto.description - Descrição do centro de custo.
 */

/**
 * Hook para obter as filas.
 *
 * @param {boolean} showDisableQueue - Indica se deve mostrar filas desabilitadas.
 * @param {Function} setLoadingForm - Função para definir o estado de carregamento do formulário.
 * @param {boolean} onlyQueuePhone - Indica se deve mostrar apenas filas de telefone.
 * @returns {{queues: Queue[], setQueus: Function}} - Retorna as filas e a função para definir as filas.
 */
export function useGetQueues(showDisableQueue, setLoadingForm, onlyQueuePhone) {
  //queue to select
  useEffect(() => {
    if (showDisableQueue) {
      QueueService.getAllShowDisable(showDisableQueue)
        .then((response) => {
          if(onlyQueuePhone){
            setQueus(response.data.data.filter((queue) => queue.is_telephony));
          }else{
            setQueus(response.data.data);
          }
        })
        .catch((err) => {
          console.log('err: ' + err);
        });
    } else {
      QueueService.getAll()
        .then((response) => {
          if(onlyQueuePhone){
            setQueus(response.data.data.filter((queue) => queue.is_telephony));
          }else{
            setQueus(response.data.data);
          }
        })
        .catch((err) => {
          console.log('err: ' + err);
          setLoadingForm(false);
        });
    }
  }, [showDisableQueue, setLoadingForm]);

  const [queues, setQueus] = useState([]);

  return {
    queues,
    setQueus
  };
}